import { render, staticRenderFns } from "./transaction-institution.vue?vue&type=template&id=700d4e70&"
import script from "./transaction-institution.vue?vue&type=script&lang=js&"
export * from "./transaction-institution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports